module.exports = __webpack_public_path__ + "static/media/2.8f5ef5d7.png";